/*
  Created by Justin Chang on July 12, 2017
*/

import React, { Component } from 'react';
import PropTypes from 'prop-types';


// Components
import { 
  CampaignPreviewCard, 
  CampaignView, 
  EngagementSwitch, 
  ConclusionCard 
} from 'dabbl-react-components'

// Assets
import iPhoneImage from '../../../shared/assets/white-iphone.png';
import GooglePixelImage from '../../../shared/assets/white-googlepixel.png';
import Placeholder1x1 from '../../../shared/assets/image-1x1.png';

const propTypes = {
  // Required
  activeEngagementId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,

  // Optional
  phonePlatform: PropTypes.oneOf(['iphone', 'android','generic']),
  align: PropTypes.oneOf(['left','center','right']),
  engagements: PropTypes.arrayOf(PropTypes.object),
  brandName: PropTypes.string,
  valuePerUser: PropTypes.number,
  width: PropTypes.number,

  // Feed
  feedText: PropTypes.string,
  feedImageURL: PropTypes.string,

  // Intro
  introText: PropTypes.string,
  introImageURL: PropTypes.string,

  // Conclusion
  logoURL: PropTypes.string,
  conclusionText: PropTypes.string,
  conclusionBackgroundColor: PropTypes.string,

  // MISC
  usesImageForVideos:PropTypes.bool,
  showQAAnswer:PropTypes.bool
};

const defaultProps = {
  align:'center',
  width:300,
  height:600,
  phonePlatform: 'android',
  engagements: [],
  brand: {},
  valuePerUser: 0,
  feedText:'',
  feedImageURL: '',
  introText: '',
  introImageURL: '',
  logoURL: '',
  conclusionText: '',
  conclusionBackgroundColor: '',
  usesImageForVideos:false,
  showQAAnswer:false,
  hideTotalValue:false,
  cta: PropTypes.shape({
    color: PropTypes.string,
    text: PropTypes.string,
    link: PropTypes.string
  }),
};

class PhonePreview extends Component {

  componentDidMount(){
    this.framePreview.onload = () => {
      let origin = `${window.location.protocol}//${window.location.hostname+(window.location.port ? ':'+window.location.port: '')}`
      this.framePreview.contentWindow.postMessage(this.getPreviewProps(this.props), origin);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return nextProps.phonePlatform !== this.props.phonePlatform || nextProps.align !== this.props.align
  }

  componentWillReceiveProps(nextProps) {
    if (this.framePreview) {
      this.framePreview.contentWindow.postMessage(this.getPreviewProps(nextProps), "*");
    }
  }

  getPreviewProps(props){
    return JSON.stringify({
      activeEngagementId: props.activeEngagementId,
      brandName: props.brandName,
      feedText: props.feedText,
      feedImageURL: props.feedImageURL,
      logoURL: props.logoURL,
      conclusionText: props.conclusionText,
      conclusionBackgroundColor: props.conclusionBackgroundColor,
      valuePerUser: props.valuePerUser,
      engagements: props.engagements,
      usesImageForVideos: props.usesImageForVideos,
      showQAAnswer: props.showQAAnswer,
      hideTotalValue: props.hideTotalValue,
      cta: props.cta
    })
  }

  getScreenPosition() {
    const { phonePlatform } = this.props;

    switch (phonePlatform) {
      case 'iphone':
        return {
          overflow: "hidden",
          position: "absolute",
          top: "12%",
          bottom: "12%",
          left: "6%",
          right: "6%",
        };

      case 'android':
      default:
        return {
          overflow: "hidden",
          position: "absolute",
          top: "12%",
          bottom: "13.5%",
          left: "6%",
          right: "6%",
        };
    }
  }

  getPreviewFrame(){
    const phonePreviewUri = `${window.location.protocol}//${window.location.hostname+(window.location.port ? ':'+window.location.port: '')}/phonepreview`

    return (
      <iframe
        style={{
          height: '100%',
          width:'100%'
        }}
        src={phonePreviewUri}
        sandbox="allow-same-origin allow-scripts"
        ref={(framePreview) => { this.framePreview = framePreview; }}
      >
      </iframe>
    )
  }

  render() {
    const {
      phonePlatform, width, height, align,
    } = this.props;

    if(phonePlatform === 'generic'){
      return (
        <div style={{height:550 * (height/550)}}>
          <div
            className="PhonePreview"
            style={{
              height:550,
              overflow: "hidden",
              transform:`scale(${height/550},${height/550})`,
              transformOrigin:`top ${align}`,
              borderRadius:'2rem',
              border:'1px solid #C5C5C5',
              backgroundColor:'white',
              boxShadow:'0 24px 24px rgba(0,0,0,0.1)'
            }}
          >
            {/* Phone Picture */}
            <div
              className="PhonePreview_screen"
              style={{
                backgroundColor:'#FFF',
                overflow: "hidden",
                position: "absolute",
                border: '1px solid #C5C5C5',
                top:33,
                bottom:33,
                left:14,
                right:14
              }}
            >
              {this.getPreviewFrame()}
            </div>
          </div>
        </div>
      )
    }


    return (
      <div
        className="PhonePreview"
        style={{
          height:(width * 2) + 20,
          overflow: "hidden"
        }}
      >
        {/* Phone Picture */}
        <div
          style={{
            overflow: "hidden",
            transform:`scale(${width/300})`,
            transformOrigin:'top left'
          }}
        >
          <img
            className="PhonePreview_img"
            src={(phonePlatform === 'android') ? GooglePixelImage : iPhoneImage}
            alt="Preview of activities on cell phones"
          />

          {/* Screen Container - use position: absolute for all children */}
          <div
            className="PhonePreview_screen"
            style={this.getScreenPosition()}
          >
            {this.getPreviewFrame()}
          </div>
        </div>
      </div>
    );
  }
}

PhonePreview.propTypes = propTypes;
PhonePreview.defaultProps = defaultProps;

export default PhonePreview;



// WEBPACK FOOTER //
// ./src/shared/components/PhonePreview/PhonePreview.js